import { LoanProductCategory } from '@mediaingenuity/totallymoney.types'

import Box from '@totallymoney/ui/components/Box'
import CategoryNavigation from '@totallymoney/ui/components/CategoryNavigation'
import Grid from '@totallymoney/ui/components/Grid'
import Stack from '@totallymoney/ui/components/Stack'

import {
    GetUnscoredCategoriesFilter,
    UnscoredLoanProductsCategory,
} from '@appTypes/LoansApi.interface'

import useAppQueryState from '@hooks/useAppQueryState'

import { getCategoryLoanFilterLimits } from '@utils/getCategoryLoanFilterLimits'
import { getUnscoredCategoryPath } from '@utils/getUnscoredCategoryPath'

import UnscoredTableFilter from '../UnscoredTableFilter'

interface UnscoredTableHeaderProps {
    activeCategory: LoanProductCategory
    categories: UnscoredLoanProductsCategory[]
    filter: GetUnscoredCategoriesFilter
    onCategoryChange: (category: LoanProductCategory) => void
    onSortChange: (sortKey: string) => void
    sortValue: string
}

const UnscoredTableHeader = ({
    categories,
    activeCategory,
    filter,
    onCategoryChange,
}: UnscoredTableHeaderProps) => {
    const { goToRouteWithAppState, getRouteUrl } = useAppQueryState()

    const categoryDetails = categories.map(category => ({
        displayName: category.displayName,
        value: category.id,
        url: getRouteUrl(getUnscoredCategoryPath(category.id)),
    }))

    const alternativeProductsCategory = {
        displayName: 'Alternative Products',
        value: 'AlternativeProducts' as LoanProductCategory,
        url: getRouteUrl(getUnscoredCategoryPath('AlternativeProducts')),
    }

    const loanFilterLimits = getCategoryLoanFilterLimits(activeCategory)

    return (
        <Grid>
            <Stack space="space20" gridColumn="1/13">
                <Box ml="-space10">
                    <CategoryNavigation
                        categories={categoryDetails.concat([
                            alternativeProductsCategory,
                        ])}
                        hasPadding={false}
                        initialActiveCategory={activeCategory}
                        onCategoryChange={category => {
                            goToRouteWithAppState(
                                getUnscoredCategoryPath(
                                    category.value as LoanProductCategory
                                ),
                                { shallow: true }
                            )

                            onCategoryChange?.(
                                category.value as LoanProductCategory
                            )
                        }}
                    />
                </Box>

                {activeCategory !== 'Secured' ? (
                    <UnscoredTableFilter
                        loanFilterLimits={loanFilterLimits}
                        loanAmount={filter.loanAmount}
                        loanTerm={filter.loanTerm}
                    />
                ) : null}
            </Stack>
        </Grid>
    )
}

export default UnscoredTableHeader
